<!-- Button -->
<button [matMenuTriggerFor]="userActions" mat-icon-button>
    <span class="relative ">
        <!-- <img
            class="w-7 h-7 rounded-full
            *ngIf="showAvatar"
            [svgIcon]="'heroicons_outline:user-circle'"> -->
        <!-- *ngIf="!showAvatar || !user.avatar" -->
        <mat-icon class="mb-2" [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span
            class="absolute right-0 bottom-2 w-2 h-2 rounded-full bg-green-500"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ users }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="directprofile()">
        <mat-icon class="icon-size-6 pb-10" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <!-- <button mat-menu-item onClick="window.open('//testrnf.tawk.help')">
    <mat-icon
        class="icon-size-7 text-dark mt-1 cursor-pointer"
        [svgIcon]="'heroicons_solid:question-mark-circle'"></mat-icon>
        <span>Help Desk</span>
    </button> -->
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>Status</span>
    </button> -->
    @if (!isSuperUser) {
        <button mat-menu-item (click)="changepass()" class="text-md">
            <mat-icon class="icon-size-6 pb-10" [svgIcon]="'heroicons_outline:key'"></mat-icon>
            <span>Change Password</span>
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon class="mb-2" [svgIcon]="'mat_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
